import { OptionalPayment } from '../generated/OptionalPayment';
import { UserAuth } from '../generated/UserAuth';

export class OptionalPaymentDTO {
  public user_auth: UserAuth = new UserAuth();
  public optional_payment: OptionalPayment = new OptionalPayment();
}
